import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpendingPlaninline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6.575 7.5a.575.575 0 0 1-1.15 0v-.925H4.5a.575.575 0 0 1 0-1.15h.925V4.5a.575.575 0 1 1 1.15 0v.925H7.5a.575.575 0 1 1 0 1.15h-.925zm7.5 4.688a.575.575 0 0 0-.575-.576h-3a.575.575 0 1 0 0 1.15h3a.575.575 0 0 0 .575-.575",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeWidth: 1.15,
			d: "M1.5 3.75A2.25 2.25 0 0 1 3.75 1.5h4.5a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25h-4.5A2.25 2.25 0 0 1 1.5 8.25z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.15,
			d: "M12.75 7.5h1.5a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25h-4.5a2.25 2.25 0 0 1-2.25-2.25v-1.5"
		})
	]
});
export default SvgSpendingPlaninline;
